import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { formatDataBeforeView } from '../../../helpers/GeneralHelper';
import * as model from '../../../models/RequirementsModel';
import { useAuth } from '../../../context/AuthContext';

export const RequirementView = ({module, showModal, setShowModal, data}) => {

  const inputFields = {
    requirement_name: 'Requirement Name',
    client_name: 'Client',
    contact_name: 'POC',
    manager_name: 'Delivery Manager',
    recruiter_name: 'Recruiter',
    requirement_no_of_positions: 'No. of Positions',
    requirement_location: 'Location',
    requirement_experience_total: 'Years of Experience (Total)',
    requirement_experience_relevant: 'Years of Experience (Relevant)',
    requirement_skills: 'Top 3 Skills',
    requirement_skills_secondary: 'Secondary Skills',
    requirement_contract_duration: 'Contract Duration',
    requirement_bill_rate: 'Bill Rate (Monthly)',
    requirement_pay_rate: 'Pay Rate (Monthly)',
    requirement_job_description: 'Job Description',
    requirement_shift_timing: 'Shift Timing',
    mode_of_work_name: 'Mode of Work',
    requirement_mode_of_interview: 'Mode of Interview',
    requirement_remarks: 'Remarks',
    status_name: 'Status',
    requirement_update_time: 'Updated At',
    requirement_create_time: 'Created At',
  }
  const formatOptions = [
    {
      'type': 'datetime',
      'column': 'requirement_update_time',
    },
    {
      'type': 'datetime',
      'column': 'requirement_create_time',
    },
  ];

  const { state } = useAuth();
  let user_data = state.user_data;

  const [fields, setFields] = useState(inputFields);
  useEffect(() => {
    if (data) {
      setFields(formatDataBeforeView(data, formatOptions));

      const fetchSelectedSkills = async() => {
        if (! data || ! data._requirement_id) {
          return;
        }
  
        try {
          const response = await model.getSelectedSkills(user_data.user_token, data._requirement_id);
  
          if (typeof response != typeof undefined) {
            let pSkills = [];
            let sSkills = [];
            response.data.skills.forEach(function(item) {
              if (item.type == 'main') {
                pSkills.push(item.skill_name);
              } else {
                sSkills.push(item.skill_name);
              }
            });
  
            setFields((prev) => ({ ...prev, 'requirement_skills': pSkills.join(', ') }));
            setFields((prev) => ({ ...prev, 'requirement_skills_secondary': sSkills.join(', ') }));
          }
        } catch (error) {
          console.error(error);
        }
      };
  
      fetchSelectedSkills();
    }
  }, [data]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
      <Modal.Header closeButton>
          <Modal.Title>View {module.singularTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-bordered table-hover table-sm">
          <tbody>
            {Object.keys(inputFields).map((item) => 
              <tr key={item}>
                {item == 'requirement_job_description' ?
                  <>
                    <td>{inputFields[item]}</td>
                    <th dangerouslySetInnerHTML={{__html: fields[item]}}></th>
                  </>
                  :
                  <>
                    <td style={{width: '140px'}}>{inputFields[item]}</td>
                    <th>{fields[item]}</th>
                  </>
                }
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};
